// extracted by mini-css-extract-plugin
module.exports = {"card":"Cards_card__IwwXZ","container":"Cards_container__2-xcY","heading":"Cards_heading__36Pfg","image":"Cards_image__3QU9Z"};